import React from 'react';
import { ResultsRow, ResultsData } from 'components/styled-components';
import styled from 'styled-components';

const Row = ({ data }) => (
  <ResultsRow>
    <TableDataWithHeaders>
      {data.vendorRequestID ? data.vendorRequestID : 'N/A'}
    </TableDataWithHeaders>
    <TableDataWithHeaders>{data.userID}</TableDataWithHeaders>
    <TableDataWithHeaders>{data.userName}</TableDataWithHeaders>
    <TableDataWithHeaders>{data.date}</TableDataWithHeaders>
    <TableDataWithHeaders>{data.action}</TableDataWithHeaders>
    <TableDataWithHeaders>{data.modifyMessage}</TableDataWithHeaders>
  </ResultsRow>
);

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(1):before {
      content: 'Assessment ID';
    }
    &:nth-of-type(2):before {
      content: 'User ID';
    }
    &:nth-of-type(3):before {
      content: 'User Name';
    }
    &:nth-of-type(4):before {
      content: 'Date & Time';
    }
    &:nth-of-type(5):before {
      content: 'Action';
    }
    &:nth-of-type(6):before {
      content: 'Details';
    }
  }
`;

export default Row;
